import * as LD from 'launchdarkly-js-client-sdk'
import React, { PropsWithChildren, useCallback, useEffect, useState } from 'react'

import { defaultFeatuerFlagsState, FeatureFlagsContext } from './utils'

import { WHITE_LABEL_THEMES } from '~lib/constants'

interface FeatureFlagsProviderProps {
  domain: string
  userId: string
}

function FeatureFlagsProvider({ children, domain, userId }: PropsWithChildren<FeatureFlagsProviderProps>) {
  const [clientFlags, setClientFlags] = useState(defaultFeatuerFlagsState)

  const getProvider = useCallback(async () => {
    const user = {
      key: userId ?? domain,
      custom: { domain },
    }

    // TODO - reasearch why NEXT_PUBLIC_LAUNCH_DARKLY_CLIENT_ID may be absent
    const client = LD.initialize(process.env.NEXT_PUBLIC_LAUNCH_DARKLY_CLIENT_ID ?? '623b3b69f14b84148d4f782b', user)
    await client.waitUntilReady()

    setClientFlags({
      key: client.variation('theme-key', WHITE_LABEL_THEMES.IGNITION),
      researchHub: client.variation('research-hub-module', true),
      competitiveIntelligence: client.variation('competitive-intelligence-module', true),
      productRoadmap: client.variation('product-roadmap-module', true),
      billing: client.variation('billing-module', true),
      renameReleaseNotesAsProjectUpdates: client.variation('rename-release-notes-as-project-updates', false),
      expiredTrialLimitation: client.variation('expired-trial-limitation', true),
      tasksKanbanView: client.variation('tasks-kanban-view', true),
    })
  }, [domain, userId])

  useEffect(() => {
    getProvider()
  }, [getProvider])

  return <FeatureFlagsContext.Provider value={clientFlags}>{children}</FeatureFlagsContext.Provider>
}

export default FeatureFlagsProvider
